import { PartitionStatus } from '@servicetitan/marketing-tenant-management-api';

export const partitionStatusProps: Record<
    PartitionStatus,
    {
        displayName: string;
    }
> = {
    [PartitionStatus.NONE]: {
        displayName: 'None',
    },
    [PartitionStatus.NEW]: {
        displayName: 'New',
    },
    [PartitionStatus.DELETED]: {
        displayName: 'Deleted',
    },
    [PartitionStatus.ACTIVE]: {
        displayName: 'Active',
    },
    [PartitionStatus.ONBOARDING]: {
        displayName: 'Onboarding',
    },
    [PartitionStatus.SUSPENDED]: {
        displayName: 'Suspended',
    },
};
